import * as React from "react";
import { CmsContentPage } from "@grandvisionhq/bloomreach";
import { T as TealiumContentPageView } from "../TealiumContentPageView.js";
const Page = (props) => /* @__PURE__ */ React.createElement(TealiumContentPageView, null, /* @__PURE__ */ React.createElement(CmsContentPage, { ...props }));
export {
  Page
};
//# sourceMappingURL=content.js.map
